import React, { createContext, useContext, useState, ReactNode } from "react";

interface FileUploadContextType {
  fileUploading: boolean;
  setFileUploading: (loading: boolean) => void;
}

const FileUploadContext = createContext<FileUploadContextType | undefined>(
  undefined
);

export const FileUploadProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [fileUploading, setFileUploading] = useState(false);

  return (
    <FileUploadContext.Provider value={{ fileUploading, setFileUploading }}>
      {children}
    </FileUploadContext.Provider>
  );
};

export const useFileUpload = () => {
  const context = useContext(FileUploadContext);
  if (!context) {
    throw new Error("useFileUpload must be used within a FileUploadProvider");
  }
  return context;
};
